import React from 'react';

import DailyMatterItem, { DailyMatterItemBase } from '../DailyMatterItem';
import WorkContentArea, { WorkContentAreaProps } from './WorkContentArea';

/**
 * アサイン済日次業務アイテムプロパティ
 */
type ShiftCalendarItemAssignedProps = DailyMatterItemBase &
  WorkContentAreaProps;

/**
 * アサイン済日次業務アイテム
 * @param props - プロパティ
 * @returns JSX要素
 */
const ShiftCalendarItemAssigned: React.FunctionComponent<
  ShiftCalendarItemAssignedProps
> = ({ dailyMatterSummary, outsourcerMembers, ...props }) => {
  return (
    <DailyMatterItem
      {...props}
      customerName={dailyMatterSummary?.customerName}
      disabledButton={false}
      matterName={dailyMatterSummary?.matterName}
      onClickMatterName={props.onClickMatterName}
      workContents={() => (
        <WorkContentArea
          dailyMatterSummary={dailyMatterSummary}
          outsourcerMembers={outsourcerMembers}
        />
      )}
    />
  );
};

export default ShiftCalendarItemAssigned;
